<div class="invoice-container" id="print-section">
  <div class="online-payment-invoice" #printContent>
    <div class="flex">
      <img
        [src]="environmentConfig.logoSrc"
        [alt]="environmentConfig.imageAlt"
        class="logo"
      />
      <div class="company-detail">
        <strong>{{
          invoiceData.office == 1 ? "EZ Pin INC" : "EZ Pin DMCC"
        }}</strong>
        <p class="company-name">
          {{ userInit?.profile?.company }} ({{ userInit?.profile?.code }})
        </p>
      </div>
    </div>
    <div class="invoice-info">
      <div class="company-info">
        <strong
          >Payable to
          {{ invoiceData.office == 1 ? "EZ Pin INC" : "EZ Pin DMCC" }}</strong
        >
        <div class="company-address">
          <p>
            <span *ngIf="invoiceData.office == 1">
              7940 Silverton Ave. <br />
              Suite 101-A San Diego, <br />
              CA 92126
            </span>
            <span *ngIf="invoiceData.office == 2">
              2702-2703 Swiss Tower,<br />
              Cluster Y, JLT <br />
              Dubai, UAE
            </span>
          </p>
          <p>Funding@ezpin.com</p>
          <p *ngIf="invoiceData.office == 2">VAT No: 100497813400003</p>
        </div>
      </div>
      <div class="client-info">
        <strong>Bill to {{ userInit?.profile?.company }}</strong>
        <div class="company-address">
          <p>{{ userInit?.profile?.address }}</p>
          <p>VAT No: {{ userInit?.profile?.vat_tax_id }}</p>
        </div>
      </div>
      <div class="invoice-date align-right">
        <strong>Date</strong>
        <p>{{ todayDate | date : "dd/MM/yyyy" }}</p>
        <strong>Invoice ID</strong>
        <p>
          {{ userInit?.profile?.code }}{{ todayDate | date : "yy"
          }}{{ todayDate | date : "MM" }}{{ todayDate | date : "hh"
          }}{{ todayDate | date : "mm" }}{{ todayDate | date : "ss" }}
        </p>
      </div>
    </div>
    <div class="invoice-desc">
      <p>
        To whom it may concern, <br />
        Below is the request for funds to be transferred to your balance.
      </p>
    </div>
    <br />
    <table>
      <thead>
        <tr class="tr-border">
          <td class="head-td"><strong>Date</strong></td>
          <td class="head-td"><strong>Item</strong></td>
          <td class="head-td" class="align-right"><strong>Amount</strong></td>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-border">
          <td class="body-td">{{ todayDate | date : "d MMMM y" }}</td>
          <td class="body-td">Balance top-up by bank transfer</td>
          <td class="body-td" class="align-right">
            {{ invoiceData.currency }}{{ invoiceData.amount | number }}
          </td>
        </tr>
        <tr>
          <td class="body-td align-right" colspan="2">
            <strong>Total to transfer</strong>
          </td>
          <td class="body-td" class="align-right">
            {{ invoiceData.currency }}{{ invoiceData.amount | number }}
          </td>
        </tr>
      </tbody>
    </table>
    <br /><br />
    <div class="invoice-guide">
      <ul>
        <li>
          Payment must be made via bank transfer from a registered company
          account.
        </li>
        <li>Third-party payments are not accepted.</li>
        <li>Payments from individual accounts are not permitted.</li>
        <li>
          For bank details, please contact your designated account manager.
        </li>
      </ul>
    </div>
  </div>
  <div class="print-page" #printPage>
    <div class="fixed-image-container">
      <img src="/assets/images/bg-pattern.png" />
      <div class="wrapper overlay-text">
        <div>
          <span class="title-badge">COMPANY</span
          ><span>
            {{ invoiceData.office == 1 ? "EZ Pin INC" : "EZ Pin DMCC" }}</span
          >
        </div>
        <div>
          <span class="title-badge">ADDRESS</span
          ><span
            ><strong>{{ invoiceData.office }}</strong>
            {{
              invoiceData?.office == 1
                ? "7940 Silverton Ave. Suite 101-A San Diego, CA 92126"
                : "2702-2703 Swiss Tower, Cluster Y, JLT Dubai, UAE"
            }}</span
          >
        </div>
        <div>
          <span class="title-badge">EMAIL</span><span>Funding@ezpin.com</span>
        </div>
        <div>
          <span class="title-badge">PHONE</span
          ><span>
            {{
              invoiceData?.office == 1 ? "+1 833 236 1001" : "+971 4 58 90 666"
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
